import React from 'react';
import Navbar from '../components/Navbar';
import About from '../components/About';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';
import SEOHelmet from '../components/SEOHelmet';
import { pagesSEO } from '../utils/seoConfig';

const AboutPage = () => {
  return (
    <div className="about-page">
      <SEOHelmet 
        title={pagesSEO.about.title}
        description={pagesSEO.about.description}
        keywords={pagesSEO.about.keywords}
        canonical={pagesSEO.about.canonical}
      />
      <Navbar />
      <Breadcrumb />
      <main>
        <h1 className="page-title sr-only">關於我們 - 聯漢室內設計工作室</h1>
        <About />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage; 